import { type UserSummary } from '@/lib/types';

export const enum ChallengeSharingResult {
  ERROR_USER_NOT_FOUND = 'ERROR_USER_NOT_FOUND',
  ERROR_USER_IS_SELF = 'ERROR_USER_IS_SELF',
  ERROR_USER_ALREADY_ADDED = 'ERROR_USER_ALREADY_ADDED',
  SUCCESS = 'SUCCESS',
}

export type IndividualUserInviteSuccessResponse = {
  challengeSharingResult: ChallengeSharingResult.SUCCESS;
  user: UserSummary;
};

export type IndividualUserInviteErrorResponse = {
  challengeSharingResult:
    | ChallengeSharingResult.ERROR_USER_NOT_FOUND
    | ChallengeSharingResult.ERROR_USER_IS_SELF
    | ChallengeSharingResult.ERROR_USER_ALREADY_ADDED;
  user: null;
};

export type UserInviteResponse = Record<
  string,
  IndividualUserInviteSuccessResponse | IndividualUserInviteErrorResponse
>;
